<template>
<div>
    <div class="full">
        <div class="mainheader">
            <div class="half">
                {{ $t('pages.employeeData.workTime') }}
            </div>
            <!-- <div class="half right">
                <div class="full">
                    <b-button style="display: inline;" pill variant="outline-success" @click="showModal('modal-createfile')">
                        <i class="fas fa-upload"></i>&nbsp;&nbsp;Hochladen
                    </b-button>
                </div>
            </div> -->
        </div>
    </div>
    <!-- WORK BALANCES -->
    <div class="full">
        <div class="header">
            <div class="label">{{ $t('global.menubar.workbalance') }}</div>
        </div>
        <div class="full m20-bottom">
            <div class="half left">
                <div class="fourth">
                    <div class="label m4-top">{{ $t('pages.comp.selectMonth') }}</div>
                </div>
                <div class="threefourths" style="z-index: 990;">
                    <dropdownsearch id="wizard-employeeType" :state="filtersEmployeeWorkbalances"/>
                </div>
            </div>
        </div>
        <div class="full" v-if="employeeWorkbalance">
            <div class="half">
                <div class="full h20 m20-top split-bottom-tight">
                    <div class="label bold mdgreen">{{ $t('shift.template.workTime') }}</div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('workBalance.summary.target') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.workTimeRegular / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('pages.comp.previousMonth') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.prevMonthTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('pages.comp.actualProductive') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.workTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20 split-bottom-tight">
                    <div class="third left">
                        <div class="label">{{ $t('pages.comp.actualUnproductive') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.unproductiveWorkTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label bold">{{ $t('pages.comp.hourlyAccount') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label bold right float">{{ (employeeWorkbalance.workTimeBalance / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20 m20-top split-bottom-tight">
                    <div class="label bold mdgreen">{{ $t('workBalance.summary.vacation') }}</div>
                </div>
                <div class="full h20 split-bottom-tight">
                    <div class="third left">
                        <div class="label">{{ $t('workBalance.summary.vacation') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.vacationTime / 24.0 / 60.0).toFixed(2) + ' ' + $tc('global.general.day', 2) }}</div>
                    </div>
                </div>
                <div class="full h20 m20-bottom">
                    <div class="third left">
                        <div class="label bold">{{ $t('pages.comp.vacationAccount') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label bold right float">{{ (employeeWorkbalance.vacationTimeBalance / 24.0 / 60.0).toFixed(2) + ' ' + $tc('global.general.day', 2) }}</div>
                    </div>
                </div>
            </div>
            <div class="half right">
                <div class="full h20 m20-top split-bottom-tight">
                    <div class="label bold mdgreen">{{ $t('roster.view.holidays') }}</div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('roster.comp.holiday') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.holidayTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20 split-bottom-tight">
                    <div class="third left">
                        <div class="label">{{ $t('workBalance.payroll.holidayCompensationShort') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.holidayAdjustmentWorkTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label bold">{{ $t('workBalance.payroll.holidayBalance') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label bold right float">{{ (employeeWorkbalance.holidayTimeBalance / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20 m20-top split-bottom-tight">
                    <div class="label bold mdgreen">{{ $t('workBalance.summary.otherAbsences') }}</div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('indicator.crew.sick') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.sickWorkTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('workBalance.summary.nursingLeave') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.nursingVacationWorkTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('workBalance.summary.sickPay') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.wageContinuationWorkTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('workBalance.summary.trainee') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.educationWorkTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('roster.main.other') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ (employeeWorkbalance.miscTime / 60.0).toFixed(2) + ' ' + $tc('global.ui.hours', 2) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import dropdownsearch from '../../uicomponents/dropdownsearch.vue'
import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        dropdownsearch,
    },
    name: 'employeeworkingtimeaccount',
    data() {
        return {
            processing: false,
            dropdowns: [],
           
            employeeWorkbalance: null,
            itemsEmployeeWorkbalances: [],
            filtersEmployeeWorkbalances: {},
           
        }
    },
    watch: {
        employee: {
            deep: true,
            handler (val, oldVal){
                this.updateEmployeeWorkbalancesDropdown();
                this.initialSelection();
                
                
                
            }
        },
        employeeWorkbalances: {
            deep: true,
            handler (val, oldVal){
                this.updateEmployeeWorkbalancesDropdown();
                this.initialSelection();
                this.$forceUpdate();
            }
        },
        
    },
    props: [
        "employee",
        "employeeWorkbalances"
    ],
    computed: {
        ...mapGetters([
            'storeId',
            'uiDataMap',
            'storeSettings',
        ]),
        
    },
    created() {
        
        this.updateEmployeeWorkbalancesDropdown();
        this.initialSelection();
    },
    methods: {
       
        
        updateEmployeeWorkbalancesDropdown() {
            var view = this;
            this.itemsEmployeeWorkbalances = [];
            var selectedItem = {};
            for (const val of this.employeeWorkbalances) {
                var monthLabel = this.$helpers.formatDateStringTZ(val.date, 'MMMM YYYY');
                var cur = {
                    code: val.id,
                    label: monthLabel,
                    name: monthLabel,
                    obj: val
                };
                this.itemsEmployeeWorkbalances.push(cur);
            }
            if(this.itemsEmployeeWorkbalances.length > 0){
                let curMonthLabel = this.$helpers.getMomentTZ().format('MMMM YYYY');
                selectedItem = this.itemsEmployeeWorkbalances.find(i => i.label == curMonthLabel);
                if(selectedItem == null){
                    selectedItem = this.itemsEmployeeWorkbalances[0];
                }
                
            }
            
            this.filtersEmployeeWorkbalances = {
                toggled: false,
                displayedItems: this.itemsEmployeeWorkbalances,
                input: selectedItem.name,
                items: Object.values(this.itemsEmployeeWorkbalances),
                onceSelected: function ($event, item, searchbar) {
                    console.log(item);
                    view.employeeWorkbalanceSelected(item.obj);
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        
        initialSelection(){
            let view = this;
            if(this.employeeWorkbalances.length > 0){
                let curMonthLabel = this.$helpers.getMomentTZ().format('MMMM YYYY');
                this.employeeWorkbalance= this.employeeWorkbalances.find(i => view.$helpers.formatDateStringTZ(i.date, 'MMMM YYYY') == curMonthLabel);
                if(this.employeeWorkbalance == null){
                    this.employeeWorkbalance = this.employeeWorkbalances[0];
                }
                
            }else{
                this.employeeWorkbalance = null;
            }
        },
        employeeWorkbalanceSelected(employeeWorkbalance){
            this.employeeWorkbalance = employeeWorkbalance;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
